import { Pipe, PipeTransform } from '@angular/core';
import { Intervention } from 'src/app/core/models/intervention';

@Pipe({ name: 'filterInterventions' })
export class FilterInterventionsPipe implements PipeTransform {
  transform(interventionList: Intervention[], goalId: number): Intervention[] {
    if (interventionList && interventionList.length && goalId != null) {
      return interventionList.filter((intervention) => intervention.goalid === goalId);
    }

    return [];
  }
}
